// src/Components/Icons/LogoutIcon.tsx
import React from 'react';
import styled from 'styled-components';

const StyledLogoutIcon = styled.svg`
  width: 30px;
  height: 30px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  transition: fill 0.2s ease;
`;

const LogoutIcon: React.FC = () => (
  <StyledLogoutIcon viewBox="0 0 24 24">
    <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
  </StyledLogoutIcon>
);

export default LogoutIcon;